import * as React from 'react'
import {memo} from 'react'

import {UpdateProvider} from '../../../../../../contexts/update'
import createSimpleStream from '../../../../../../utils/simpleStream'
import {DEBOUNCE_PERIOD} from '../../../../../common/Fetcher/Fetcher'
import NestedBuildTypeLine from '../../../../../common/NestedSubprojectsAndBuildTypes/BuildTypeLine/BuildTypeLine'

import BuildTypeLineFetcher from './BuildTypeLine.fetcher'
import type {ContainerProps} from './BuildTypeLine.types'

const NO_BUILDS = 'No builds'

function BuildTypeLine(props: ContainerProps) {
  const {buildTypeId, nested} = props

  const [hasBuilds, setHasBuilds] = React.useState<boolean | null>(null)

  const onLoadingComplete = React.useCallback((arg1: boolean) => setHasBuilds(arg1), [])

  const update$ = React.useMemo(() => createSimpleStream(DEBOUNCE_PERIOD), [])

  return (
    <UpdateProvider update={update$.fire}>
      <NestedBuildTypeLine {...props} hasContent={hasBuilds} emptyText={NO_BUILDS}>
        <BuildTypeLineFetcher
          onLoadingComplete={onLoadingComplete}
          update$={update$}
          buildTypeId={buildTypeId}
          nested={nested}
        />
      </NestedBuildTypeLine>
    </UpdateProvider>
  )
}

export default memo(BuildTypeLine)
